import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, EMPTY } from 'rxjs';
import { tap, catchError, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppLoaderService } from '../components/app-loader/app-loader.service';
import { AuthService } from '../security/auth.service';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ServerErrorsInterceptor implements HttpInterceptor {

    constructor(
        private snackBar: MatSnackBar, 
        private authService: AuthService,
        private router: Router, 
        private loader: AppLoaderService
        ) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(retry(environment.REINTENTOS)).
            pipe(tap(event => {
                if (event instanceof HttpResponse) {
                    if (event.body && event.body.error === true && event.body.errorMessage) {
                        throw new Error(event.body.errorMessage);
                    }
                }
            })).pipe(catchError((err) => {

                this.loader.cerrar();
                console.log(err);
                console.log("codigo ===" + err.status + " Mensaje===" + err.error.message + " error ====" + err);

                if (err.status == 0) {
                    this.snackBar.open('Error: No existe conexión al servidor backend', 'ERROR SERVIDOR', { duration: 10000 });
                } else if (err.status === 400) {
                    //this.snackBar.open(err.error.message, 'ERROR 400', { duration: 10000 }); //comentar para pase
                    this.snackBar.open("Error, Vuelva a intentarlo más tarde", 'ERROR 400', { duration: 10000 }); //descomentar para pase
                } else if (err.status === 401) {  //No Autorizado
                    if (!this.authService.isAutenticado()) {
                        this.authService.logout();
                    }else{
                        this.snackBar.open(err.error.message, 'ERROR 401', { duration: 10000 }); 
                        this.router.navigate(['/dashboard/inicio']);
                    }                    
                } else if (err.status === 404) {  //Not found
                    this.snackBar.open(err.error.message, 'ERROR 404', { duration: 10000 });
                } else if (err.status === 500) {
                    console.log(err.error.message);
                    //this.snackBar.open(err.error.message, 'ERROR 500', { duration: 10000 }); //comentar para pase
                    this.snackBar.open("Error, Vuelva a intentarlo más tarde", 'ERROR 500', { duration: 10000 }); //descomentar para pase
                } else {
                    //this.snackBar.open(err.error.message, 'ERROR INESPERADO', { duration: 10000 }); //comentar para pase
                    this.snackBar.open("Error, Vuelva a intentarlo más tarde", 'ERROR INESPERADO', { duration: 10000 }); //descomentar para pase                    
                }
                return EMPTY;
            }));
    }

}